import { Decimal } from 'decimal.js'

export default definePayloadPlugin(() => {
  definePayloadReducer('Decimal', data => Decimal.isDecimal(data) && data.toJSON())
  definePayloadReviver('Decimal', data => new Decimal(data))
})
